import RESTSerializer from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
export default class HolidayHour extends RESTSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }
  modelNameFromPayloadKey() {
    return 'menu-sync/holiday-hour';
  }
  serializeIntoHash(hash, type, record, options) {
    super.serializeIntoHash(hash, type, record, options);

    // eslint-disable-next-line no-param-reassign
    hash.holidayHour = hash['menuSync/holidayHour'];

    // eslint-disable-next-line no-param-reassign
    delete hash['menuSync/holidayHour'];
  }
}